import CitySEOHead from "@/components/feature/CitySEOHead";
import DecaturHeroSection from "./components/HeroSection";
import DecaturStickyNav from "./components/StickyNav";
import DecaturProcessingTimeSection from "./components/ProcessingTimeSection";
import DecaturServicesSection from "./components/ServicesSection";
import DecaturLocalAreaSection from "./components/LocalAreaSection";
import DecaturTestimonialsSection from "./components/TestimonialsSection";
import DecaturAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DecaturComparisonSection from "./components/ComparisonSection";
import DecaturMistakesSection from "./components/MistakesSection";
import DecaturHowItWorksSection from "./components/HowItWorksSection";
import DecaturFAQSection, { faqs } from "./components/FAQSection";
import DecaturHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DecaturFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DecaturPage() {
  return (
    <>
      <CitySEOHead
        city="Decatur"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/decatur"
        title="Emergency Passport Decatur, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Decatur, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving DeKalb County travelers. Get your emergency passport fast!"
        geoPlacename="Decatur, Georgia"
        geoPosition="33.7748;-84.2963"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Decatur passport, same day passport Decatur, fast passport Georgia, DeKalb County passport"
      />
      <div className="font-sans">
        <DecaturHeroSection />
        <DecaturStickyNav />
        <DecaturProcessingTimeSection />
        <DecaturLocalAreaSection />
        <DecaturServicesSection />
        <DecaturTestimonialsSection />
        <DecaturAcceptanceFacilitiesSection />
        <DecaturComparisonSection />
        <DecaturMistakesSection />
        <DecaturHowItWorksSection />
        <DecaturFAQSection />
        <DecaturHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/decatur" state="GA" />
        <DecaturFinalCTA />
      </div>
    </>
  );
}